import React, { createContext, useContext, useState } from 'react';

const ShopIdContext = createContext();

export const useShopId = () => {
  const context = useContext(ShopIdContext);
  if (!context) {
    throw new Error('useShopId must be used within a ShopIdProvider');
  }
  return context;
};

export const ShopIdProvider = ({ children }) => {
  const [shopId, setShopId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const updateShopId = (newShopId) => {
    setShopId(newShopId);
    setError(null);
  };

  const setShopIdError = (errorMessage) => {
    setError(errorMessage);
    setIsLoading(false);
  };

  const setShopIdLoading = (loading) => {
    setIsLoading(loading);
  };

  const value = {
    shopId,
    isLoading,
    error,
    updateShopId,
    setShopIdError,
    setShopIdLoading,
  };

  return (
    <ShopIdContext.Provider value={value}>
      {children}
    </ShopIdContext.Provider>
  );
};
